
<app-academic-headers></app-academic-headers>
<router-outlet></router-outlet>
<app-academic-footers></app-academic-footers>